import ChecPopConfirm from './ChecPopConfirm'

export default ChecPopConfirm
